<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<h2 class="fm_title" id="list"><span class="bold">List of Illustrations</span></h2>
<p class="list">Blair Castle, Perthshire. Author’s own image.</p>
<p class="list">Huntingtower, Perth. View looking north. Author’s own image.</p>
<p class="list">Huntingtower, Perth. View looking south, only the two towers of the original castle now remain. Author’s own image with permission of Historic Environment Scotland.</p>
<p class="list">John Murray, Duke of Atholl. From the collection at Blair Castle.</p>
<p class="list">Katherine Hamilton, Duchess of Atholl. From the collection at Blair Castle.</p>
<p class="list">Memorial at St Mary’s, Kilmuir, Skye, erected to Lord Thomas Fraser, 10th Lord Lovat, father of Simon, died at Dunvegan 1699. Author’s own image.</p>
<p class="list">Dowager Duchess Anne Hamilton. Alamy image.</p>
<p class="list">Lady Margaret Nairne. Alamy image.</p>
<p class="list">John Murray, Marquis of Tullibardine, died at the Battle of Malplaquet. From the collection at Blair Castle.</p>
<p class="list">William Murray, Marquis of Tullibardine. From the collection at Blair Castle.</p>
<p class="list">Lord George Murray. From the collection at Blair Castle.</p>
<p class="list">Battle of Preston. Royal Collection Trust/© Her Majesty Queen Elizabeth II 2019</p>
<p class="list">Sheriffmuir. Author’s own image.</p>
<p class="list">Gathering stone at Sheriffmuir where the Jacobites are said to have assembled before the battle. Author’s own image.</p>
<p class="list">Map of the area around Sheriffmuir. Alamy image.</p>
<p class="list">Picture of the ‘Battle of Sheriffmuir’ here entitled the ‘Battle of Dumblain’ (Dunblane); artist not assigned. Picture on display at Dunblane Museum and used with their kind permission.</p>
<p class="list">Scone Palace where James III briefly held court. Image Maddy Anderson 2019.</p>
<p class="list">Amelia Murray, wife of Lord George. Image from the collection at Blair Castle.</p>
<a id="page_vii"></a>
<p class="list">Tullibardine Chapel where Lord George wanted to be interred with his wife and children. It stood next to Tullibardine Castle, of which there are no remains. Author’s own image.</p>
<p class="list">Sign at Sheriffmuir commemorating the 300-year anniversary of the battle. Author’s own image.</p>
<p class="list">Glenfinnan Monument, where William Marquis of Tullibardine, raised the standard marking the start of the 1745 Rising. Author’s own image.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_List.vue?0223077e